import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-framenavigation',
  templateUrl: './blog-framenavigation.component.html',
  styleUrls: ['./blog-framenavigation.component.scss']
})
export class BlogFramenavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
